import { injectable, inject } from 'inversify';
import { NavigationEvent, SectionClosedEvent } from '@/app/statistics/events/navigation-events';
import { SectionStatusEvent, SectionStatusChangedEvent } from '@/app/statistics/events/section-status-events';
import { createCommand } from '@/app/tracking/api';
import { StoreCommandExecutor } from '@/app/tracking/common';
import * as Api from '../api'

@injectable()
export class SectionStateProjection {
  constructor(
    @inject(StoreCommandExecutor)
    private readonly commandExecutor: StoreCommandExecutor) {
  }

  public async handle(event: NavigationEvent | SectionStatusEvent) {
    switch (event.name) {
      case 'section-closed':
        await this.handleSectionClosed(event.payload);
        return true;
      case 'section-status-changed':
        await this.handleSectionStatusChanged(event.payload);
        return true;
    }

    return false;
  }

  private async handleSectionStatusChanged(event: SectionStatusChangedEvent) {

    const isCompleted = event.progress.status === 'completed';
    const isPreviousCompleted = event.previousProgress.status === 'completed';

    const command = createCommand<Api.UpdateSectionStateCommand>('update-section-state', {
      sectionId: event.sectionId,
      progress: event.progress,
      status: isCompleted ? Api.SectionStatus.completed :
            Api.SectionStatus.incomplete
    });

    this.commandExecutor.queue(command);

    if (isCompleted && !isPreviousCompleted) {
      const completeCommand = createCommand<Api.CompleteSectionCommand>('complete-section', {
        sectionId: event.sectionId,
        meta: {
          title: event.title
        }
      });
      this.commandExecutor.queue(completeCommand);
    }
  }

  private async handleSectionClosed(event: SectionClosedEvent) {
    const command = createCommand<Api.AddSectionDurationCommand>('add-section-duration', {
      sectionId: event.sectionId,
      durationSeconds: event.durationSeconds
    });

    this.commandExecutor.queue(command);
  }
}
